import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { LnChevronLeftSvgIconComponent } from '../svg-icons/ln-chevron-left-svg-icon/ln-chevron-left-svg-icon.component';
import { LnChevronRightSvgIconComponent } from '../svg-icons/ln-chevron-right-svg-icon/ln-chevron-right-svg-icon.component';
import { ImageSize } from '@interfaces/images/image_size';
import { ActivoDigital } from '@interfaces/products/activo_digital_interface';
import { HorizontalSwipeDirective } from '@directives/horizontal-swipe.directive';

@Component({
  selector: 'ln-product-info-main-image',
  imports: [LnChevronLeftSvgIconComponent, LnChevronRightSvgIconComponent, HorizontalSwipeDirective],
  templateUrl: './ln-product-info-main-image.component.html',
  styleUrl: './ln-product-info-main-image.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnProductInfoMainImageComponent {
  @Output() mainImageSize = new EventEmitter<ImageSize>();
  @Input({ required: true }) activosDigitales!: ActivoDigital[];

  @ViewChild('imageScrollContainer', { static: true }) containerRef!: ElementRef;
  @ViewChild('mainImage', { static: true }) mainImageRef!: ElementRef;

  readonly tag = 'ln-product-info-main-image';
  mouseDown = false;
  translateX = 0;
  translateY = 0;
  zoomLevel = 1;
  transformStyle = '';

  @Input() selectedImageIndex = 0;
  @Output() selectedImageChange = new EventEmitter<number>();

  @HostListener('window:resize', ['$event'])
  onScreenResize() {
    this.UpdateMainImageSize();
  }

  NextImage() {
    if (this.zoomLevel === 1 && this.activosDigitales.length > 1) {
      this.selectedImageIndex =
        this.selectedImageIndex < this.activosDigitales.length - 1 ? this.selectedImageIndex + 1 : 0;
      this.selectedImageChange.emit(this.selectedImageIndex);
    }
  }

  PrevImage() {
    if (this.zoomLevel === 1 && this.activosDigitales.length > 1) {
      this.selectedImageIndex =
        this.selectedImageIndex >= 1 ? this.selectedImageIndex - 1 : this.activosDigitales.length - 1;
      this.selectedImageChange.emit(this.selectedImageIndex);
    }
  }

  onPointerHover(event: MouseEvent): void {
    if (this.zoomLevel > 1) {
      this.UpdateCords(event);
      this.transformStyle = `matrix(${this.zoomLevel}, 0, 0, ${this.zoomLevel}, 0, 0) translate(${this.translateX}px, ${this.translateY}px)`;
    }
  }

  onMouseLeave(): void {
    this.mouseDown = false;
    this.zoomLevel = 1;
    this.transformStyle = `matrix(${this.zoomLevel}, 0, 0, ${this.zoomLevel}, 0, 0)`;
  }

  UpdateCords(event: MouseEvent) {
    const container = this.containerRef.nativeElement.getBoundingClientRect();
    const x = event.clientX - container.left;
    const y = event.clientY - container.top;

    const centerX = container.width / 2;
    const centerY = container.height / 2;

    this.translateX = (centerX - x) / 2;
    this.translateY = (centerY - y) / 2;
  }

  onMouseDown(event: MouseEvent) {
    if (event.button === 0) {
      this.UpdateCords(event);
      this.mouseDown = true;
      this.zoomLevel = this.zoomLevel + 0.5;
      this.transformStyle = `matrix(${this.zoomLevel}, 0, 0, ${this.zoomLevel}, 0, 0) translate(${this.translateX}px, ${this.translateY}px)`;
    }
  }

  onMouseUp(event: MouseEvent) {
    this.mouseDown = false;
    if (event.button !== 0) {
      event.preventDefault();
      event.stopPropagation();
      this.onMouseLeave();
    }
  }

  UpdateMainImageSize() {
    const img = this.mainImageRef.nativeElement;
    const width = img.clientWidth;
    const height = img.clientHeight;
    const imageSize: ImageSize = { width: width, height: height };
    this.mainImageSize.emit(imageSize);
  }
}
